import React, { FC } from 'react';
import {
  AppBar,
  Toolbar,
  LogoWrapper,
  HeaderLeft,
  SkipNav,
} from 'components/StaticHeader/style';
// @ts-ignore
import { getConfig } from '@edx/frontend-platform';

import { useIsSpeechCraftMFE } from 'hooks';

const StaticHeader: FC<any> = ({ user }) => {
  const isSpeechCraftMFE = useIsSpeechCraftMFE();
  const baseUrl = () => getConfig().BASE_URL;
  const pathwaysLogoUrl = () => getConfig().PATHWAYS_LOGO_URL;
  const speechcraftLogoUrl = () => getConfig().SPEECHCRAFT_LOGO_URL;
  const logoUrl = () => getConfig().LOGO_URL;

  return (
    <AppBar
      sx={{ zIndex: theme => theme.zIndex.drawer + 1 }}
      enableColorOnDark={true}
      color='transparent'
    >
      <SkipNav href='#main'>Skip to main content</SkipNav>
      <Toolbar>
        <HeaderLeft>
          <LogoWrapper>
            <a href={`${baseUrl()}`}>
              <img
                src={
                  isSpeechCraftMFE
                    ? speechcraftLogoUrl()
                    : pathwaysLogoUrl()
                }
                onError={({ currentTarget }: any) => {
                  currentTarget.onerror = null;
                  currentTarget.src = logoUrl();
                }}
                alt='Toastmasters International'
              />
            </a>
          </LogoWrapper>
        </HeaderLeft>
      </Toolbar>
    </AppBar>
  );
};

export default StaticHeader;
